import {doc, getDoc, onSnapshot, setDoc} from 'firebase/firestore';
import {db} from '../../../shared/services/firebase';

export const updateBalenaStatus = async (id, updateEdgeState) => {
  await setDoc(doc(db, 'balenaUpdate', id), {tStamp: new Date()});
  updateEdgeState(id, {balenaUpdatePending: true});

  const unsubscribe = onSnapshot(
    doc(db, 'balenaUpdate', id),
    async (d) => {
      if (!d.exists()) {
        const updatedDoc = await getDoc(doc(db, 'edges', id));
        if (updatedDoc.exists()) {
          updateEdgeState(id, {...updatedDoc.data(), balenaUpdatePending: false});
        }
        unsubscribe();
      }
    },
    (error) => {
      console.error('Balena update listener failed:', error);
      updateEdgeState(id, {balenaUpdatePending: false});
      unsubscribe();
    }
  );
};
